import { render, staticRenderFns } from "./ExtraQuestions.handler.vue?vue&type=template&id=18bff4c0&"
import script from "./ExtraQuestions.handler.vue?vue&type=script&lang=ts&"
export * from "./ExtraQuestions.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports